module.exports = __webpack_public_path__ + "static/media/sign-right-img.0c3f59d5.png";